/* src/StatusApp.svelte generated by Svelte v3.18.1 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	empty,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	set_style,
	space,
	text
} from "svelte/internal";

function create_if_block(ctx) {
	let table;
	let tr0;
	let t4;
	let tr1;
	let td0;
	let t6;
	let td1;
	let t7_value = /*time1*/ ctx[3].toFixed(2) + "";
	let t7;
	let t8;
	let td1_class_value;
	let t9;
	let td2;
	let t10_value = Math.floor(/*firstRatio*/ ctx[6] * 100) / 100 + "";
	let t10;
	let t11;
	let t12_value = (/*isFirstFaster*/ ctx[5] ? "faster" : "slower") + "";
	let t12;
	let td2_class_value;
	let t13;
	let tr2;
	let td3;
	let t15;
	let td4;
	let t16_value = /*time2*/ ctx[4].toFixed(2) + "";
	let t16;
	let t17;
	let td4_class_value;
	let t18;
	let td5;
	let t19_value = Math.floor(1 / /*firstRatio*/ ctx[6] * 100) / 100 + "";
	let t19;
	let t20;
	let t21_value = (!/*isFirstFaster*/ ctx[5] ? "faster" : "slower") + "";
	let t21;
	let td5_class_value;

	return {
		c() {
			table = element("table");
			tr0 = element("tr");

			tr0.innerHTML = `<th>Script</th> 
      <th>Time elapsed</th> 
      <th></th>`;

			t4 = space();
			tr1 = element("tr");
			td0 = element("td");
			td0.textContent = "Benchmark script 1";
			t6 = space();
			td1 = element("td");
			t7 = text(t7_value);
			t8 = text("s");
			t9 = space();
			td2 = element("td");
			t10 = text(t10_value);
			t11 = text("x ");
			t12 = text(t12_value);
			t13 = space();
			tr2 = element("tr");
			td3 = element("td");
			td3.textContent = "Benchmark script 2";
			t15 = space();
			td4 = element("td");
			t16 = text(t16_value);
			t17 = text("s");
			t18 = space();
			td5 = element("td");
			t19 = text(t19_value);
			t20 = text("x ");
			t21 = text(t21_value);
			attr(td1, "class", td1_class_value = /*isFirstFaster*/ ctx[5] ? "faster" : "slower");

			set_style(td1, "--inner-width", (/*isFirstFaster*/ ctx[5]
			? /*time1*/ ctx[3] / /*time2*/ ctx[4] * 100
			: 100) + "px");

			attr(td2, "class", td2_class_value = /*isFirstFaster*/ ctx[5] ? "faster" : "slower");
			attr(td4, "class", td4_class_value = !/*isFirstFaster*/ ctx[5] ? "faster" : "slower");

			set_style(td4, "--inner-width", (!/*isFirstFaster*/ ctx[5]
			? /*time2*/ ctx[4] / /*time1*/ ctx[3] * 100
			: 100) + "px");

			attr(td5, "class", td5_class_value = !/*isFirstFaster*/ ctx[5] ? "faster" : "slower");
		},
		m(target, anchor) {
			insert(target, table, anchor);
			append(table, tr0);
			append(table, t4);
			append(table, tr1);
			append(tr1, td0);
			append(tr1, t6);
			append(tr1, td1);
			append(td1, t7);
			append(td1, t8);
			append(tr1, t9);
			append(tr1, td2);
			append(td2, t10);
			append(td2, t11);
			append(td2, t12);
			append(table, t13);
			append(table, tr2);
			append(tr2, td3);
			append(tr2, t15);
			append(tr2, td4);
			append(td4, t16);
			append(td4, t17);
			append(tr2, t18);
			append(tr2, td5);
			append(td5, t19);
			append(td5, t20);
			append(td5, t21);
		},
		p(ctx, dirty) {
			if (dirty & /*time1*/ 8 && t7_value !== (t7_value = /*time1*/ ctx[3].toFixed(2) + "")) set_data(t7, t7_value);

			if (dirty & /*isFirstFaster*/ 32 && td1_class_value !== (td1_class_value = /*isFirstFaster*/ ctx[5] ? "faster" : "slower")) {
				attr(td1, "class", td1_class_value);
			}

			if (dirty & /*isFirstFaster, time1, time2*/ 56) {
				set_style(td1, "--inner-width", (/*isFirstFaster*/ ctx[5]
				? /*time1*/ ctx[3] / /*time2*/ ctx[4] * 100
				: 100) + "px");
			}

			if (dirty & /*firstRatio*/ 64 && t10_value !== (t10_value = Math.floor(/*firstRatio*/ ctx[6] * 100) / 100 + "")) set_data(t10, t10_value);
			if (dirty & /*isFirstFaster*/ 32 && t12_value !== (t12_value = (/*isFirstFaster*/ ctx[5] ? "faster" : "slower") + "")) set_data(t12, t12_value);

			if (dirty & /*isFirstFaster*/ 32 && td2_class_value !== (td2_class_value = /*isFirstFaster*/ ctx[5] ? "faster" : "slower")) {
				attr(td2, "class", td2_class_value);
			}

			if (dirty & /*time2*/ 16 && t16_value !== (t16_value = /*time2*/ ctx[4].toFixed(2) + "")) set_data(t16, t16_value);

			if (dirty & /*isFirstFaster*/ 32 && td4_class_value !== (td4_class_value = !/*isFirstFaster*/ ctx[5] ? "faster" : "slower")) {
				attr(td4, "class", td4_class_value);
			}

			if (dirty & /*isFirstFaster, time2, time1*/ 56) {
				set_style(td4, "--inner-width", (!/*isFirstFaster*/ ctx[5]
				? /*time2*/ ctx[4] / /*time1*/ ctx[3] * 100
				: 100) + "px");
			}

			if (dirty & /*firstRatio*/ 64 && t19_value !== (t19_value = Math.floor(1 / /*firstRatio*/ ctx[6] * 100) / 100 + "")) set_data(t19, t19_value);
			if (dirty & /*isFirstFaster*/ 32 && t21_value !== (t21_value = (!/*isFirstFaster*/ ctx[5] ? "faster" : "slower") + "")) set_data(t21, t21_value);

			if (dirty & /*isFirstFaster*/ 32 && td5_class_value !== (td5_class_value = !/*isFirstFaster*/ ctx[5] ? "faster" : "slower")) {
				attr(td5, "class", td5_class_value);
			}
		},
		d(detaching) {
			if (detaching) detach(table);
		}
	};
}

function create_fragment(ctx) {
	let h3;
	let t0;
	let span;
	let t1;
	let t2;
	let div;
	let t3;
	let t4;
	let t5;
	let t6;
	let t7;
	let if_block_anchor;
	let if_block = /*time1*/ ctx[3] && /*time2*/ ctx[4] && create_if_block(ctx);

	return {
		c() {
			h3 = element("h3");
			t0 = text("Status\n  ");
			span = element("span");
			t1 = text(/*status*/ ctx[0]);
			t2 = space();
			div = element("div");
			t3 = text(/*completed*/ ctx[1]);
			t4 = text(" of ");
			t5 = text(/*total*/ ctx[2]);
			t6 = text(" scripts completed");
			t7 = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			insert(target, h3, anchor);
			append(h3, t0);
			append(h3, span);
			append(span, t1);
			insert(target, t2, anchor);
			insert(target, div, anchor);
			append(div, t3);
			append(div, t4);
			append(div, t5);
			append(div, t6);
			insert(target, t7, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (dirty & /*status*/ 1) set_data(t1, /*status*/ ctx[0]);
			if (dirty & /*completed*/ 2) set_data(t3, /*completed*/ ctx[1]);
			if (dirty & /*total*/ 4) set_data(t5, /*total*/ ctx[2]);

			if (/*time1*/ ctx[3] && /*time2*/ ctx[4]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(h3);
			if (detaching) detach(t2);
			if (detaching) detach(div);
			if (detaching) detach(t7);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { status = "Waiting for the benchmark to be executed" } = $$props;
	let { completed = 0 } = $$props;
	let { total = 2 } = $$props;
	let { time1 = 0 } = $$props;
	let { time2 = 0 } = $$props;

	$$self.$set = $$props => {
		if ("status" in $$props) $$invalidate(0, status = $$props.status);
		if ("completed" in $$props) $$invalidate(1, completed = $$props.completed);
		if ("total" in $$props) $$invalidate(2, total = $$props.total);
		if ("time1" in $$props) $$invalidate(3, time1 = $$props.time1);
		if ("time2" in $$props) $$invalidate(4, time2 = $$props.time2);
	};

	let isFirstFaster;
	let firstRatio;

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*time1, time2*/ 24) {
			$: $$invalidate(5, isFirstFaster = time1 <= time2);
		}

		if ($$self.$$.dirty & /*time2, time1*/ 24) {
			$: $$invalidate(6, firstRatio = time2 / time1);
		}
	};

	return [status, completed, total, time1, time2, isFirstFaster, firstRatio];
}

class StatusApp extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			status: 0,
			completed: 1,
			total: 2,
			time1: 3,
			time2: 4
		});
	}
}

export default StatusApp;